import React from "react";

export const BackPurpleIcon = ({onClick}) => {
    return (
        <div className={'back-purple-icon'} onClick={onClick}>
            <svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path id="Vector 39" d="M10.0769 1L2 9M2 9L10.0769 17M2 9H17" stroke="#8540DD" strokeWidth="2"
                      strokeLinecap="round"/>
            </svg>
        </div>

    );
}